import { Box, Grid2, Paper } from "@mui/material";
import * as React from "react";
import logosTefl from "../images/logoToefl.png";
import banne3 from "../images/image011.png";
import Typography from "@mui/material/Typography";
import info from "../images/info.png";
import test from "../images/test.png";
import agendar from "../images/agendar.png";
import cursos from "../images/cursos.png";
import gre from "../images/GRE.png";
import sat from "../images/satlogo.png";
import BannerToefl from "../images/bannerToefl.jpg";
import { Helmet } from "react-helmet-async";

const images = [logosTefl, gre, sat];

function Toefl() {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Cambia cada 3 segundos
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <Helmet>
        <title> DLS - TOEFL</title>

        <meta
          name="description"
          content="DLS tiene como propósito ayudar a los estudiantes a alcanzar los puntajes que requieran en el examen TOEFL iBT."
        />
        <meta
          name="keywords"
          content="direccion, bolivia, La Paz, Cochabamba, Santa Cruz, traductor, traduccion, cursos, examenes"
        />
        <meta name="author" content="DLS" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <link rel="icon" href="/favicon.ico" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="CENTRO AUTORIZADO TOEFL" />
        <meta
          property="og:description"
          content="DLS tiene como propósito ayudar a los estudiantes a alcanzar los puntajes que requieran en el examen TOEFL iBT."
        />
        <meta
          property="og:image"
          content="https://dls.com.bo/static/media/logo_DLS.6424b652d76d8584dbc3.png"
        />
        <meta property="og:url" content="http://localhost:3000/#/toefl" />

        <link rel="canonical" href="https://dls.com.bo" />
      </Helmet>
      <Box
        sx={{
          width: "auto",
          display: "block",
          textAlign: "justify",
        }}
      >
        <Box>
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={banne3}
                  alt="Digital Language Services"
                  className="animate__animated animate__fadeInLeft img-dim-banner"
                />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  display: "flex",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    padding: "20px 0",
                    clipPath: {
                      xs: "none",
                      sm: "none",
                      md: "polygon(10% 0, 100% 0, 100% 100%, 0% 100%)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "block",
                      height: "100%",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        fontWeight: "bold",
                        color: "#077f83",
                        padding: {
                          sx: "0",
                          sm: "0",
                          md: "0px 5px 0px 50px ",
                        },
                        justifyContent: "center",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "calc(9px + 1vw)",
                      }}
                    >
                      CERTIFICACION ETS, EXAMENES:
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        height: {
                          xs: "100px",
                          sm: "130px",
                          md: "100%",
                        },
                        alignItems: "center",
                      }}
                    >
                      <Box className="sequential-carousel">
                        {images.map((image, index) => (
                          <img
                            key={index}
                            src={image}
                            alt={`Slide ${index + 1}`}
                            className={`carousel-image ${
                              currentIndex === index ? "visible" : "hidden"
                            }`}
                          />
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Box sx={{ display: "block", width: "100%", paddingTop: "35px" }}>
          <a
            href="https://www.ets.org/login.html"
            target="_blank"
            rel="noreferrer"
          >
            <img src={BannerToefl} alt="toefl" style={{ width: "100%" }} />
          </a>
        </Box>
        <Box
          sx={{
            width: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            padding: "2px",
          }}
        >
          <Box
            sx={{
              maxWidth: {
                xs: "98vw",
                sm: "90vw",
                md: "70vw",
              },
              display: "block",
              padding: "2px",
            }}
          >
            <Box sx={{ display: "block" }}>
              <Box>
                <Box
                  sx={{
                    display: "block",
                    textAlign: "center",
                    padding: "25px",
                  }}
                ></Box>
              </Box>

              <Box
                sx={{
                  justifyContent: "center",
                  display: "block",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="h5" sx={{ padding: "15px" }}>
                  <b>CENTRO AUTORIZADO TOEFL</b>
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "80%",
                      borderRadius: {
                        xs: "15px",
                        sm: "15px",
                        md: "13% 15px 15px 13% / 50% 15px 15px 50%",
                      },
                      textAlign: {
                        xs: "center",
                        sm: "center",
                        md: "left",
                      },
                    }}
                  >
                    <Grid2 container spacing={2}>
                      <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <img
                            className="img-info"
                            src={info}
                            alt="Digital Language Services"
                          />{" "}
                        </Box>
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 12, md: 9, lg: 9 }}>
                        <Box
                          sx={{
                            display: "flex",
                            paddingRight: "10px",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <Typography variant="body1">
                            <ul>
                              <li>
                                DLS tiene como propósito ayudar a los
                                estudiantes a alcanzar los puntajes que
                                requieran en el examen TOEFL iBT. Este examen es
                                considerado mundialmente como una herramienta
                                que mide exactamente el nivel de Inglés.
                              </li>
                              <br />
                            </ul>
                          </Typography>
                        </Box>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "25px 0",
                  justifyContent: "center",
                  display: "block",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="h5" sx={{ padding: "15px" }}>
                  <b>DESCUBRE TU NIVEL</b>
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "80%",
                      borderRadius: {
                        xs: "15px",
                        sm: "15px",
                        md: "13% 15px 15px 13% / 50% 15px 15px 50%",
                      },
                      textAlign: {
                        xs: "center",
                        sm: "center",
                        md: "left",
                      },
                    }}
                  >
                    <Grid2 container spacing={2}>
                      <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <img
                            className="img-info"
                            src={test}
                            alt="Digital Language Services"
                          />{" "}
                        </Box>
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 12, md: 9, lg: 9 }}>
                        <Box
                          sx={{
                            display: "flex",
                            paddingRight: "10px",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <Typography variant="body1">
                            <ul>
                              <li>
                                Cada estudiante debe tomar un examen de admisión
                                para ver su nivel, puede tomar este examen de
                                lunes a viernes entre 8 a.m. y 11 a.m. o 3 p.m.
                                a 7 p.m. El requerimiento mínimo para ingresar a
                                cualquier curso de clases TOEFL iBT, es de 75
                                puntos sobre 120.
                              </li>
                              <br />
                            </ul>
                          </Typography>
                        </Box>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "25px 0",
                  justifyContent: "center",
                  display: "block",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="h5" sx={{ padding: "15px" }}>
                  <b>NUESTROS CURSOS</b>
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "80%",
                      borderRadius: {
                        xs: "15px",
                        sm: "15px",
                        md: "13% 15px 15px 13% / 50% 15px 15px 50%",
                      },
                      textAlign: {
                        xs: "center",
                        sm: "center",
                        md: "left",
                      },
                    }}
                  >
                    <Grid2 container spacing={2}>
                      <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <img
                            className="img-info"
                            src={agendar}
                            alt="Digital Language Services"
                          />{" "}
                        </Box>
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 12, md: 9, lg: 9 }}>
                        <Box
                          sx={{
                            display: "flex",
                            paddingRight: "10px",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <Typography variant="body1">
                            <ul>
                              <li>
                                Una vez que determinemos su nivel, podremos
                                informarle cuanto tiempo necesita para alcanzar
                                un promedio de 95 a 110 puntos. Nuestro curso de
                                TOEFL iBT tiene como duración mínimamente un mes
                                y como máximo cuatro meses, dependiendo de su
                                nivel y del puntaje que requiera alcanzar.
                              </li>
                              <br />
                            </ul>
                          </Typography>
                        </Box>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "25px 0",
                  justifyContent: "center",
                  display: "block",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="h5" sx={{ padding: "15px" }}>
                  <b>ELIGE EL MEJOR HORARIO Y MODALIDAD</b>
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "80%",
                      borderRadius: {
                        xs: "15px",
                        sm: "15px",
                        md: "13% 15px 15px 13% / 50% 15px 15px 50%",
                      },
                      textAlign: {
                        xs: "center",
                        sm: "center",
                        md: "left",
                      },
                    }}
                  >
                    <Grid2 container spacing={2}>
                      <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <img
                            className="img-info"
                            src={cursos}
                            alt="Digital Language Services"
                          />{" "}
                        </Box>
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 12, md: 9, lg: 9 }}>
                        <Box
                          sx={{
                            display: "flex",
                            paddingRight: "10px",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <Typography variant="body1">
                            <ul>
                              <li>
                                Proveemos tanto clases en línea como
                                presenciales. Asegurando una atención
                                personalizada e individualizada tanto en
                                nuestros grupos de 2 a 5 personas como en
                                nuestras clases individuales.
                              </li>
                              <br />
                            </ul>
                          </Typography>
                        </Box>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Toefl;
